<script setup>
  import { onBeforeRouteUpdate } from "vue-router";
  import { storeToRefs } from "pinia";
  import { useMCampaignStore } from "@stores/mCampaign";

  const mCampaignStore = useMCampaignStore();
  const { fetchMCampaign } = mCampaignStore;
  const { hasMCampaignChanged } = storeToRefs(mCampaignStore);

  // Children (Audiences/Creatives/Campaigns) share currentMCampaign, so refetch only when the
  // campaign changes or there are unsaved edits to discard — not on clean sibling-tab switches,
  // nor when a child only syncs its selection into the query (e.g. ?creative=).
  onBeforeRouteUpdate(async (to, from) => {
    if (to.path === from.path) return;
    if (to.params.token !== from.params.token || hasMCampaignChanged.value) {
      await fetchMCampaign(to.params.token);
    }
  });
</script>

<template>
  <RouterView :key="$route.params.token" />
</template>
